import React, { useEffect, useState } from "react";
import Display from "./Display";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const InputAndApi = () => {
  const [search, setSearch] = useState();
  const [city, setCity] = useState("Pune");
  const [weatherInfo, setWeatherInfo] = useState({});
  const [error, setError] = useState(false);

  const handelSubmit = (e) => {
    e.preventDefault();
    setCity(search);
  };

  useEffect(() => {
    const fetchAPI = async () => {
      const url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&%20&units=metric&appid=45514b9c93b3dc13f8c7f041b0e3caf3`;

      await fetch(url);
      const response = await fetch(url);
      const data = await response.json();

      const { humidity, pressure, temp } = data.main;
      const { name: cityName, visibility, dt } = data;
      const { main: weahterMood } = data.weather[0];
      const { country } = data.sys;
      const { speed } = data.wind;

      const details = {
        humidity,
        pressure,
        temp,
        cityName,
        visibility,
        dt,
        weahterMood,
        country,
        speed,
      };
      setWeatherInfo(details);
    };
    fetchAPI();
  }, [city]);

  return (
    <>
      <div className="searchBar">
        <form onSubmit={handelSubmit}>
          <input
            type="text"
            placeholder="Enter City..."
            onChange={(e) => setSearch(e.target.value)}
          />
          <button>
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </button>
        </form>
      </div>
      {error ? "No City Found" : <Display weatherInfo={weatherInfo} />}
    </>
  );
};

export default InputAndApi;
